import { render, staticRenderFns } from "./hy.vue?vue&type=template&id=49316257&scoped=true&"
var script = {}
import style0 from "./hy.vue?vue&type=style&index=0&id=49316257&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49316257",
  null
  
)

export default component.exports